import { memo, CSSProperties } from 'react';

import dynamic from 'next/dynamic';

import { Currencies } from '@constants/constants';
import { getCurrencySymbol } from '@utils/utils';

import { StyledListingItemPriceLabel } from './styled';
import Price from '../item-price';

const OriginalPrice = dynamic(
  () => import('@components/ui/price/OriginalPrice')
);

export interface ListingItemLabelProps {
  style?: CSSProperties;
  originalPrice?: number | string;
  priceWithDiscount?: number | string;
  currency?: string;
  rate?: number;
  total?: boolean;
}

const PriceLabel = ({
  originalPrice,
  priceWithDiscount,
  currency = Currencies.TL,
  style,
  rate,
  total,
  ...otherProps
}: ListingItemLabelProps) => {
  return (
    <StyledListingItemPriceLabel style={style} {...otherProps}>
      {priceWithDiscount ? (
        <>
          <Price
            total={total}
            price={Number(priceWithDiscount)}
            originalPriceCurrency={getCurrencySymbol(currency)}
            showDecimal={false}
            currencyFontSize={24}
            currencyFontWeight={600}
          >
            {rate > 0 ? (
              <OriginalPrice
                price={+originalPrice}
                currency={getCurrencySymbol(currency)}
                noLine={false}
                size={16}
              />
            ) : null}
          </Price>
        </>
      ) : null}
    </StyledListingItemPriceLabel>
  );
};

export default memo(PriceLabel);
